import type { WrapperProps } from "@/modules/companies/client/components/Wrapper/types"
import type { PagesRouterPage, PagesRouterPageProps } from "@/types"
import type { GetServerSideProps } from "next"

import { Information } from "@/modules/companies/client/components/Information/Information"
import { Wrapper } from "@/modules/companies/client/components/Wrapper/Wrapper"
import { getServerSideInformationProps } from "@/modules/companies/client/utils/getServerSideInformationProps"

const CompanyInformation: PagesRouterPage<WrapperProps> = props => (
  <Wrapper {...props}>
    <Information />
  </Wrapper>
)

const getServerSideProps: GetServerSideProps<PagesRouterPageProps<WrapperProps>> = async context =>
  getServerSideInformationProps(context)

export { CompanyInformation as default, getServerSideProps }
